import React from 'react';
import { EntityAskAI } from '../common/EntityAskAI';

interface PersonAskAIProps {
  personName: string;
  fileIds: string[];
  teamId: string;
}

const getSuggestions = (personName: string) => [
  `What did ${personName} discuss?`,
  `What are ${personName}'s main action items?`,
  `What problems did ${personName} mention?`,
  `What are ${personName}'s key goals?`,
  `Create a summary report about ${personName}`,
];

export const PersonAskAI: React.FC<PersonAskAIProps> = ({
  personName,
  fileIds,
  teamId,
}) => {
  return (
    <EntityAskAI
      entityName={personName}
      entityType="person"
      fileIds={fileIds}
      teamId={teamId}
      getSuggestions={getSuggestions}
    />
  );
};

export default PersonAskAI;
